// extracted by mini-css-extract-plugin
export default {"iconStatusSmall":"style_iconStatusSmall__g1chk"};